// External Dependencies
import React from 'react';
import PropTypes from 'prop-types';

// Local Dependencies
import DojoAppBar from './app-bar';
import FooterContent from '../shared/footer';
import LoginButton from './login-button';

// Local Variables
const propTypes = {
  children: PropTypes.node,
};

const rootStyles = {
  position: 'relative',
};

const headerStyles = {
  zIndex: 5000,
  width: '100%',
  position: 'fixed',
  top: 0,
};

const childrenStyles = {
  margin: '85px 0px 0px 0px',
  height: '100%',
};

const adminLoginStyles = {
  bottom: 0,
  position: 'absolute',
  right: 0,
};

// Component Definition
const AppMainContainer = props => (
  <div style={rootStyles}>
    <header style={headerStyles}>
      <DojoAppBar />
    </header>
    <section style={childrenStyles}>
      {props.children}
    </section>
    <FooterContent />
    <div style={adminLoginStyles}>
      <LoginButton />
    </div>
  </div>
);

AppMainContainer.propTypes = propTypes;
export default AppMainContainer;



/** WEBPACK FOOTER **
 ** ./src/app-main-container/index.js
 **/